module.exports = {
  companyFullName: "Ekalsutra Edtech Private Limited",
  companyShortName: "Ekalsutra",
  companyWebsite: "www.ekalsutra.com",
  supportEmail: "support@ekalsutra.com",
  salesNumber: "+91-8545904757",
  supportNumber: "+91-9792669957",
  registeredAddress: "Goshaisinghpur, Sultanpur, Uttar Pradesh, India, 228131",
  lucknowBranchAddress:
    "Ekalsutra Office, Innovation Hub, 4th Floor, CAS Building, AKTU, Jankipuram, Lucknow, 226031",
  ambedkarNagarBranchAddress:
    "Ekalsutra Office, REC, Tanda Road, Ambedkar Nagar, Uttar Pradesh, India, 224122",
  ayodhyaBranchAddress:
    "Ekalsutra Office, IET Campur, Near Naka Bypass, Tanda Road, Ambedkar Nagar, Uttar Pradesh, India, 224001",
};
